import React, { useContext } from 'react';
import { QuizContext } from "./ConfigurableQuizContainer";
import ElementHTML from "./QuizElementHTML";
import { Checkbox } from '@atlaskit/checkbox';
import { Radio } from '@atlaskit/radio';
import styled from "@emotion/styled";
import { colors } from "@atlaskit/theme";

export default function Choices() {

  const { updateChoiceValue, currentCard, cardChoiceChange } = useContext(QuizContext);

  return (
    <>
      {Object.keys(currentCard.choices).map(function(item){
        let choice = currentCard.choices[item];

        let choiceLabel = <>
          {choice.icon ? (
            <img className="icon" src={choice.icon} />
          ): ""}
            <ElementHTML className="texts" content={choice.title} />
        </>;

        return <div key={item}>
          <Choice onClick={() => cardChoiceChange(choice.key)}
          className={`${currentCard.cardType} ${choice.isChecked ? 'checked' : ''}`}>

            {currentCard.cardType == "checkbox" ? (
              <Checkbox
              isChecked={choice.isChecked}
              label={choiceLabel} />
            ) : (
              <Radio
              isChecked={choice.isChecked}
              label={choiceLabel} 
              />
            )}
          </Choice>

          {choice.openEnded && choice.isChecked ? (
            <ChoiceInput type="text" onChange={(e) => updateChoiceValue(choice.key, e)} placeholder={choice.openEndedPlaceholder ? choice.openEndedPlaceholder : ''} value={choice.openEndedValue} />
          ) : ""}
        </div>
      })}

    </>
  )
}

const ChoiceInput = styled.input`
  width: 100%;
  padding: 10px 20px;
  font-family: 'Charlie Text', sans-serif;
  font-size: 1rem;
`;

const Choice = styled.button`
  appearance: none;
  cursor: pointer;
  border: 0;
  display: block;
  width: 100%;
  padding: 20px;
  margin: 0 0 10px 0;
  border-radius: 3px;
  background-color: ${colors.N30};

  * {
    pointer-events: none;
    text-align: left;
    font-family: 'Charlie Text', sans-serif;
    font-size: 1rem;
  }

  ul {
    list-style-type: disc;
    padding-top: 15px;
  }

  &:hover {
    background-color: ${colors.N40};
  }

  &.checked {
    background-color: ${colors.B75};
  }

  > label {
    > *:first-child {
      margin-top: 3px;
    }
    > *:last-child {
      flex-grow: 1;
      align-items: center;
      display: flex;

      img {
        margin-right: 3px;
        margin-bottom: 0;
        max-height: 15px;
        width: auto;
        height: auto;
      }
    }
  }
`;
